module.exports = __webpack_public_path__ + "429e0a1e914f819b0e2b7a4c91261ba1.svg";